export const COMPANY_NAME = 'Clearwater Golf Cart Rentals';
export const COMPANY_LOCATION = 'Clearwater, FL';
export const PHONE_NUMBER = '(727) 555-CART';
export const PHONE_NUMBER_RAW = '727-555-2278';
export const PHONE_NUMBER_TEL = 'tel:727-555-2278';
export const EMAIL = 'clearwatergolfcartrentals@gmail.com';
export const COPYRIGHT_YEAR = '2025';